var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { PADDING } from "../constants";
var StyledImg = styled("img")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  right: ", "px;\n  bottom: ", "px;\n  ", "\n  max-height: calc(100% - ", "px);\n  max-width: calc(100% - ", "px);\n"], ["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  right: ", "px;\n  bottom: ", "px;\n  ",
    "\n  max-height: calc(100% - ", "px);\n  max-width: calc(100% - ", "px);\n"])), PADDING / 2, PADDING / 2, PADDING / 2, PADDING / 2, function (_a) {
    var size = _a.size, isSet = _a.isSet;
    return "\n    " + (!isSet && "opacity: 0.3;") + "\n    max-width: " + (size - PADDING) + "px;\n    max-height: " + (size - PADDING) + "px;\n  ";
}, PADDING, PADDING);
export default StyledImg;
var templateObject_1;
